import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
const textRef = React.createRef();
const selectRef = React.createRef();
const refModal = React.createRef();

function EditQuestion(props) {
  const [questionId, setQuestionId] = useState('');
  const [text, setText] = useState('');
  const [type, setType] = useState('');
  const [questionOptions, setQuestionOptions] = useState([]);
  const [redirectToQuestions, setRedirectToQuestions] = useState(false);
  const [questionLoaded, setQuestionLoaded] = useState(false);
  const [newAnswer, setNewAnswer] = useState('');
  const { firestore } = props;

  useEffect(() => {
    M.AutoInit();
    var elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  }, []);

  const initLoading = () => {
    M.updateTextFields();
    if (textRef.current) {
      M.textareaAutoResize(textRef.current);
    }
    if (selectRef.current) {
      M.FormSelect.init(selectRef.current);
    }
  };

  useEffect(initLoading, [questionLoaded]);

  const validateQuestion = () => {
    //TODO: we need to validate before update
    return true;
  };

  const selectAnswer = (eIndex) => {
    let qo = questionOptions;
    let no = [];
    for (let index in qo) {
      no.push({ option: qo[index].option, isAnswer: parseInt(eIndex) === parseInt(index) });
    }
    setQuestionOptions(no);
  };

  const deleteAnswer = (eIndex) => {
    let qo = questionOptions;
    let no = [];
    for (let index in qo) {
      if (parseInt(eIndex) !== parseInt(index)) {
        no.push({ option: qo[index].option, isAnswer: qo[index].isAnswer });
      }
    }
    setQuestionOptions(no);
  };

  const openAnswerModal = () => {
    const modal = M.Modal.getInstance(refModal.current);
    modal.open();
  };

  const addNewAnswer = (e) => {
    e.preventDefault();
    const modal = M.Modal.getInstance(refModal.current);
    modal.close();

    let qo = questionOptions;
    let no = [];
    for (let index in qo) {
      no.push({ option: qo[index].option, isAnswer: qo[index].isAnswer });
    }
    no.push({ option: newAnswer, isAnswer: false });
    setQuestionOptions(no);
    setNewAnswer('');
  };

  const renderNewAddAnswer = () => {
    return (
      <div ref={refModal} id="modal-add-answer" className="modal">
        <div className="modal-content">
          <h5>Add New Answer</h5>
          <div className="input-field col s12">
            <textarea id="taAnswer" className="materialize-textarea" name="answer" value={newAnswer} onChange={(e) => setNewAnswer(e.target.value)}></textarea>
            <label htmlFor="taAnswer">Answer</label>
          </div>
        </div>
        <div className="modal-footer">
          <a href="#!" onClick={(e) => addNewAnswer(e)} className="waves-effect btn btn-flat">
            Confirm
          </a>
          <a href="#close" className="modal-close waves-effect btn btn-flat">
            Cancel
          </a>
        </div>
      </div>
    );
  };

  const updateQuestion = () => {
    const updatedQuestion = {
      updatedAt: firestore.FieldValue.serverTimestamp(),
      question: text,
      type: type,
      questionOptions: questionOptions,
    };

    console.log(updatedQuestion);
    if (!validateQuestion(updatedQuestion)) {
      alert('Question no valid');
      return;
    }

    firestore
      .collection('triviaQuestions')
      .doc(questionId)
      .update(updatedQuestion)
      .then(() => {
        setRedirectToQuestions(true);
      })
      .catch((error) => console.error(error));
  };

  const { auth, question } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (redirectToQuestions) return <Redirect to="/questions" />;

  if (!questionLoaded && question) {
    console.log(question);
    setQuestionId(question.id);
    setType(question.type);
    setText(question.question);
    setQuestionOptions(question.questionOptions);

    setQuestionLoaded(true);
    return <div></div>;
  }

  const renderAnswers = () => {
    return (
      <div className="row">
        <div className="input-field col s12">
          {questionOptions.map((answer, index) => {
            return (
              <p key={answer.option}>
                <label>
                  <input name="answers" type="radio" onChange={(e) => selectAnswer(index)} checked={answer.isAnswer ? 'checked' : ''} />
                  <span className="radio-option">{answer.option}</span>
                  <a href="#deleteAnswer" onClick={(e) => deleteAnswer(index)}>
                    <i className="material-icons radio-option-delete">delete</i>
                  </a>
                </label>
              </p>
            );
          })}
          <br />
          <a href="#newAnswer" className="waves-effect waves-light btn" onClick={(e) => openAnswerModal()}>
            New Answer
          </a>
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            <div className="row">
              <div className="col s12">
                <h4>Edit Question</h4>
                <small>{questionId}</small>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <textarea ref={textRef} id="taQuestion" className="materialize-textarea" name="question" value={text} onChange={(e) => setText(e.target.value)}></textarea>
                <label htmlFor="taQuestion">Question</label>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <select ref={selectRef} value={type} className="icons" onChange={(e) => setType(e.target.value)}>
                  <option value="" disabled>
                    Select your type
                  </option>
                  <option value="1">Type 1</option>
                  <option value="2">Type 2</option>
                  <option value="3">Type 3</option>
                  <option value="4">Type 4</option>
                  <option value="5">Type 5</option>
                </select>
                <label>Type</label>
              </div>
            </div>
            {renderAnswers()}
            {renderNewAddAnswer()}
          </div>
          <div className="card-action">
            <a href="#update" className="waves-effect waves-light btn btn-large" onClick={updateQuestion}>
              UPDATE
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  const questionId = ownProps.match.params.id;
  const question = state.firestore.data['currentQuestion'];
  return {
    id: questionId,
    question: question ? question[questionId] : null,
    auth: state.firebase.auth,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => [{ collection: 'triviaQuestions', where: ['id', '==', props.id], storeAs: 'currentQuestion' }]),
)(EditQuestion);
